import { render, staticRenderFns } from "./PurchaseFish.vue?vue&type=template&id=56a6d5c6&scoped=true"
import script from "./PurchaseFish.vue?vue&type=script&setup=true&lang=ts"
export * from "./PurchaseFish.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PurchaseFish.vue?vue&type=style&index=0&id=56a6d5c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a6d5c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56a6d5c6')) {
      api.createRecord('56a6d5c6', component.options)
    } else {
      api.reload('56a6d5c6', component.options)
    }
    module.hot.accept("./PurchaseFish.vue?vue&type=template&id=56a6d5c6&scoped=true", function () {
      api.rerender('56a6d5c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/PurchaseFish.vue"
export default component.exports